import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class ResourcesComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  public columns = [
    { name: "Name", prop: "displayname" },
    { name:"Tag Type",prop:"tagcategories_ids" },
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 

  imageUrl=environment.apiUrls.imageUrl;
  

  searchVal:any;
  @ViewChild('name') inputName
  user_role:any
  guideline_data:any
  constructor( public apiService:ApiService,
               private modalService: NgbModal,
               public toastr: ToastrService,
               private spinner: NgxSpinnerService) { 
                this.user_role=JSON.parse(localStorage.getItem('user'))
              }

  ngOnInit(): void {
    this.getResourcesByUser(this.user_role.id)
    
  }
  getResourcesByUser(id){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllResourcesStudentByCourse(id).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows = res?.data?.items
      let data =[]
      data = res?.data?.items.map( item => item.resource)
      this.rows = data.flat(Infinity);
      const uniqueArray = Array.from(new Set(this.rows.map(obj => obj._id))).map(id => {
        return this.rows.find(obj => obj._id === id);
    });
    this.rows = uniqueArray
    this.page.totalPages = this.rows.length
    })
  }
  filter(data){
    // this.spinner.show(undefined,
    //   {
    //     type: 'ball-triangle-path',
    //     size: 'medium',
    //     bdColor: 'rgba(0, 0, 0, 0.8)',
    //     color: '#fff',
    //     fullScreen: true
    //   });
    // this.apiService.filterAssignment(data).subscribe((res:any)=>{
    //   if(res?.statusCode === 200){
    //     this.spinner.hide();
    //     this.rows = res?.data
    //     this.page.totalPages = res?.data?.length
    //   }
    // })
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    // this.getProjectsByUser(this.course_id.id)
  }

  pageChangeData(page:any){
    // this.apiService.getAllFaqByCourse(page.offset +1,page.pageSize).subscribe((res:any)=>{
    //   this.rows = res?.data?.items
    //   this.page.totalPages = res?.data?.totalCount
    // })
  }
  
}
